import {
  UpdateStatusPriority,
  UpdateStatusType,
} from '@models/UpdateStatus.model';
import { useContext, useState } from 'react';
import { IUpdateRawQueryList } from '@models/Update.model';

// import { NewTableLoading } from './NewTable.loading';
import {
  NoUpdatesContainer,
  // IconContainer,
  // LoadingLine,
  // ArrowWrapper,
  // Test,
  // HeaderText,
  // SortingIconContainer,
  UpdatesTableAsset,
} from '../../Updates.styles';
import { AssetUpdatesContext } from '../../Updates.query';
import { getUpdateCell } from './NewTable.utils';
import { FieldHeaderUpdatesAsset } from './FieldHeaderUpdatesAsset';

export type ColumnNames = 'Status' | 'Subject' | 'Assignee' | 'Date' | 'none';

interface IHeader {
  title: ColumnNames;
}

const headings: IHeader[] = [
  {
    title: 'Status',
  },
  {
    title: 'Subject',
  },
  {
    title: 'Assignee',
  },
  {
    title: 'Date',
  },
];
const NewTable = () => {
  const { updateStatusId, updatesQuery } = useContext(AssetUpdatesContext);

  // const { updates } = useAppSelector();

  const getUpdateStatuses = () => {
    return updatesQuery?.data || [];
  };

  const updateStatuses = getUpdateStatuses();

  const statusOrder = [
    UpdateStatusPriority.URGENT,
    UpdateStatusPriority.IMPORTANT,
    UpdateStatusPriority.NONCRITICAL,
    UpdateStatusType.NEW,
    null,
  ];

  const [sortBy, setSortBy] = useState<ColumnNames>('none');

  const [sortState, setSortState] = useState<undefined | 'ASC' | 'DESC'>(
    undefined,
  );

  const sortByColumn = (a: IUpdateRawQueryList, b: IUpdateRawQueryList) => {
    if (sortBy === 'Status') {
      if (sortState === 'ASC')
        return (
          statusOrder.indexOf(b.priority) - statusOrder.indexOf(a.priority)
        );
      if (sortState === 'DESC')
        return (
          statusOrder.indexOf(a.priority) - statusOrder.indexOf(b.priority)
        );
      return 0;
    }
    if (sortBy === 'Subject') {
      if (sortState === 'ASC') return b.subject.localeCompare(a.subject, 'en');
      if (sortState === 'DESC') return a.subject.localeCompare(b.subject, 'en');
      return 0;
    }
    if (sortBy === 'Assignee') {
      if (a.aName && b.aName) {
        if (sortState === 'ASC') return b.aName.localeCompare(a.aName, 'en');
        if (sortState === 'DESC') return a.aName.localeCompare(b.aName, 'en');
        return 0;
      }
    }
    if (sortBy === 'Date') {
      if (!a.date && !b.date) {
        return 0;
      }
      if (!a.date) {
        return 1;
      }
      if (!b.date) {
        return -1;
      }
      return sortState === 'ASC'
        ? a.date?.getTime() - b.date?.getTime()
        : b.date?.getTime() - a.date?.getTime();
    }
    return 0;
  };

  const sortingToggle = (columnName: ColumnNames) => {
    if (sortState === undefined) {
      setSortState('ASC');
      setSortBy(columnName);
      return;
    }
    if (sortState === 'ASC') {
      setSortState('DESC');
      setSortBy(columnName);
      return;
    }
    setSortState(undefined);
    setSortBy('none');
  };

  const sortedUpdateStatuses = updateStatuses.sort(sortByColumn);

  return (
    <NoUpdatesContainer className="new-icon reset-global">
      <UpdatesTableAsset>
        <thead>
          <tr>
            {headings.map((heading, index, array) => {
              const isFirst = index === 0;
              const isLast = index === array.length - 1;
              const classList = [isFirst && 'first', isLast && 'last'];
              const className = classList.filter(_item => !!_item).join(' ');

              return (
                <th
                  key={heading.title}
                  data-fieldname={heading.title}
                  className={className}
                >
                  <FieldHeaderUpdatesAsset
                    label={heading.title}
                    sortString={heading.title}
                    onSort={() => {
                      sortingToggle(heading.title);
                    }}
                    currentSort={sortBy}
                    direction={sortState}
                  />
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {sortedUpdateStatuses.map(updateStatus => {
            return (
              <UpdatesTableAsset.Tr
                cells={headings.map(heading => {
                  return {
                    id: heading.title,
                    node: getUpdateCell(heading.title, updateStatus),
                  };
                })}
                key={updateStatus.id}
                onClick={() => {
                  updateStatusId.set(updateStatus.id);
                }}
              />
            );
          })}
        </tbody>
      </UpdatesTableAsset>
    </NoUpdatesContainer>
  );

  // return (
  //   <NoUpdatesContainer>

  //     <TableBody>
  //       {updateStatuses?.sort(sortByColumn).map(updateStatus => (
  //         <Test key={updateStatus.id}>
  //           <RowPrioritized
  //             onClick={() => {
  //               updateStatusId.set(updateStatus.id);
  //             }}
  //           >
  //             {updates.loadingUpdateId.includes(updateStatus.id) && (
  //               <LoadingLine>
  //                 <PulseLoader color="#1371fe" />
  //               </LoadingLine>
  //             )}
  //             <RowInnerPrioritized>
  //               <WrapperRow>
  //               </WrapperRow>
  //               <WrapperRow>
  //               </WrapperRow>

  //             </RowInnerPrioritized>
  //           </RowPrioritized>
  //         </Test>
  //       )) || <NewTableLoading />}
  //     </TableBody>
  //   </NoUpdatesContainer>
  // );
};
export { NewTable };
